// Bluetooth heart-rate strap or watch (standard Heart Rate service).
import { t } from '../i18n/index.js';
import { BleDevice, valueOf, type GattServer, type StatusFn } from './ble.js';
import { parseHeartRate, type Reading } from './gatt.js';

export class HeartRate extends BleDevice {
  constructor(private readonly onData: (d: Reading) => void, onStatus: StatusFn) { super(onStatus); }
  protected fallbackName() { return t.devices.hr; }
  protected filters() { return { filters: [{ services: ['heart_rate'] }] }; }
  protected async attach(srv: GattServer) {
    const c = await (await srv.getPrimaryService('heart_rate')).getCharacteristic('heart_rate_measurement');
    c.addEventListener('characteristicvaluechanged', e => this.onData({ hr: parseHeartRate(valueOf(e)) }));
    await c.startNotifications();
  }
}
